import { createStore } from 'vuex';
import auth from '@/store/modules/auth';
import env from '@/store/modules/env';
import partner from '@/store/modules/partner';
import priceEditor from '@/store/modules/priceEditor';

const vuex = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    env,
    partner,
    priceEditor,
  },
});

export default vuex;
